import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';

export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);

  try {
    await Auth.currentAuthenticatedUser();
    return true;
  } catch {
    sessionStorage.setItem('redirectAfterLogin', state.url);
    router.navigate(['/login']);
    return false;
  }
};